import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {
  addContactService,
  deleteContactService,
  listContactsService,
  searchContactByEmailService,
  type UpdateContactPayload,
  updateContactService,
} from "./contacts.service";
import type {Contact} from "./contacts.types";

export const CONTACTS_QUERY_KEY = ["contacts"] as const;

export const useContacts = () => {
  const query = useQuery<Contact[], Error>({
    queryKey: CONTACTS_QUERY_KEY,
    queryFn: listContactsService,
    staleTime: 60_000,
  });

  return {
    contacts: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export const useSearchContactByEmail = () => {
  return useMutation<Contact | null, Error, string>({
    mutationFn: searchContactByEmailService,
  });
};

export const useAddContact = () => {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, string>({
    mutationFn: addContactService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: CONTACTS_QUERY_KEY});
    },
  });
};

export const useUpdateContact = () => {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, UpdateContactPayload>({
    mutationFn: updateContactService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: CONTACTS_QUERY_KEY});
    },
  });
};

export const useDeleteContact = () => {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, string>({
    mutationFn: deleteContactService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: CONTACTS_QUERY_KEY});
    },
  });
};
